import { NoDataFound } from '@fabric-ui/components';
import NoPoliciesAndViolations from '@fabric-ui/icons/svg/emptyStates/NoPolicesAndViolations.svg';
import NoViolationsFound from '@fabric-ui/icons/svg/emptyStates/NoViolationsFound.svg';
import { flex, refetchingStyle } from '@fabric-ui/theme';
import { Box, Button } from '@mui/material';
import { useNavigate } from '@utils/AvRouter';
import Pluralize from 'pluralize';
import { usePoliciesList } from '../../hooks/useGetPolicies';
import { PAGE_PATHS } from '../../types';
import { ExecutionRuleType } from '../../types/executionRules.types';

export const policyViolationsNoDataFound = ({ projDisplayName, isRefetching }) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate({ to: `../${PAGE_PATHS.POLICIES}/create` });
  };
  const { data: rows = [], isLoading } = usePoliciesList({ type: ExecutionRuleType.ASSET_POLICY });

  if (isLoading) {
    return <div> Loading...</div>;
  }
  if (rows.length > 0) {
    return (
      <NoDataFound
        headline="All in compliance"
        img={NoPoliciesAndViolations}
        style={isRefetching ? { containerStyle: refetchingStyle } : {}}
        callToAction={
          <Box sx={flex.colStartCenter}>
            <Box sx={{ ...flex.justifyStartCenter }}>Policies are enforced, and everything looks good</Box>
            no violations to address at this time.
          </Box>
        }
      />
    );
  }

  return (
    <NoDataFound
      headline={`No ${Pluralize(projDisplayName)} Found`}
      img={NoViolationsFound}
      style={isRefetching ? { containerStyle: refetchingStyle } : {}}
      callToAction={
        <Box sx={flex.colStartCenter}>
          <Box sx={{ ...flex.justifyStartCenter }}>
            <Button onClick={handleNavigate}>Create a policy</Button> to get started.
          </Box>
          Any violations will appear on this page as they occur.
        </Box>
      }
    />
  );
};
